<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="dismiss()">
    <svg class="unity-icon unity-icon-times">
      <use xlink:href="#unity-icon-times"></use>
    </svg>
  </button>
</div>
<div class="modal-body" style="font-size: 14px; white-space: pre-line">
  {{ message }}
</div>
<div class="modal-footer">
  <button unity-button type="button" classes="primary" (click)="accept()" ngbAutofocus>
    {{ btnOkText }}
  </button>
  <button unity-button type="button" classes="ghost" (click)="decline()">{{ btnCancelText }}</button>
</div>
